import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "IconTeaserGrid",
    component: () => (__SERVER__ ? require("./icon-teaser-grid-view") : import("./icon-teaser-grid-view"))
});

export default definition;
